// Module
var code = `<div class="js-font-picker">
    {{#.font}}
        <terceraFontLookup selectedItem="{{.Family}}" enabled="{{~/enabled}}"/>
        <terceraNumeric minValue="6" maxValue="32" value="{{.Height}}" enabled="{{~/enabled}}"/>
        <terceraButton canCheck="true" text="B" terceraButtonStyle="weight-button" checked="{{~/bold}}" enabled="{{~/enabled}}"/>
    {{/}}
</div>`;
// Exports
export default code;